export const spacingTokens = {
  SpacingNone: '0rem',
  Spacing2: '0.125rem',
  Spacing4: '0.25rem',
  Spacing8: '0.5rem',
  Spacing12: '0.75rem',
  Spacing16: '1rem',
  Spacing20: '1.25rem',
  Spacing24: '1.5rem',
  Spacing28: '1.75rem',
  Spacing32: '2rem',
  Spacing36: '2.25rem',
  Spacing40: '2.5rem',
} as const;
